import React, {useState, useEffect, useContext} from 'react';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import classNames from 'classnames';
import FooterNav from './components/FooterNav';
import {DataContext} from './context/DataContext'

const AppShell = ({children}) => {
    const [footerOpacity, setFooterOpacity] = useState("");
    const dataContext = useContext(DataContext)
    useEffect(() => {
        if (typeof window !== "undefined") {
            window.onscroll = () => {
            let currentScrollPos = window.pageYOffset;
            let maxScroll = document.body.scrollHeight - window.innerHeight;
            if (currentScrollPos > 0 && currentScrollPos < maxScroll) {
                setFooterOpacity("0")
            } else {
                setFooterOpacity("100")
            }
            }
        }
    }, []);

    const footerStyling = classNames({
        'w-full sm:hidden z-10 fixed flex justify-between left-0 bottom-0' : true,
        'opacity-0': footerOpacity === '0',
        'opacity-100': footerOpacity === '100'
    });
    const sidebarStyle = classNames({
        "sm:px-0 sm:pt-2 sm:w-48" : dataContext.hideSidebar === true,
        'sm:px-0 sm:pt-2 sm:w-12' :  dataContext.hideSidebar === false
    });
    const toggleSidebarBorder = classNames({
        "bg-white sm:bg-gray-700 sm:-mt-8 pt-16 flex border-r border-gray-600 h-full fixed top z-50 sm:z-0" : dataContext.hideSidebar === true,
        "bg-white sm:bg-gray-700 sm:-mt-8 pt-16 flex h-full fixed top z-50 sm:z-0" : dataContext.hideSidebar === false
    })
  return (
    <div class="h-screen">
        <div className="border-b z-50 border-gray-600 w-full bg-white">
            <Navbar />
        </div>
        <div className="flex bg-gray-700 mt-0 sm:mt-16 h-full sm:h-auto mb-auto sm:mb-0">
            <div className={toggleSidebarBorder}>
                <div className={sidebarStyle}>
                    <Sidebar />
                </div>
            </div>
            <div className="w-full mt-16 sm:mt-0 sm:ml-64 sm:pl-1 mb-auto lg:pl-20">
                {children}
            </div>
        </div>
        <div className={footerStyling}>
            <FooterNav />
        </div>
    </div>
  );
};

export default AppShell;
